import { render, staticRenderFns } from "./KgjtWebsiteOfflineOrderSend.vue?vue&type=template&id=471f6840&scoped=true&"
import script from "./KgjtWebsiteOfflineOrderSend.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteOfflineOrderSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f6840",
  null
  
)

export default component.exports